import { Component, Input } from '@angular/core';

import { DatePipe } from '@angular/common';
import * as $ from 'jquery';
import { NotificationService } from '../services/notification.service';
import { Patient } from '../models/patient.model';
import { PatientService } from '../services/patient.service';

@Component({
  selector: 'app-patient-detail',
  templateUrl: './patient-detail.component.html'
})
export class PatientDetailComponent {

  constructor(public service: PatientService, private notificationService: NotificationService, private datepipe: DatePipe) { }

  model: Patient;
  @Input() id: string;

  ngOnInit() {

    this.service.get(this.id).subscribe(
      res => {
        this.model = res as Patient;
      },
      err => { console.log(err); this.notificationService.notifyFailure(); }
    );

  }
}
